/**
 * TODO: get all languages
 */
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { getDate, formatDateTime, formatMonthYear, renderExpertRate } from '@atheneum/api/dist/lib'
import { userApi } from '@atheneum/api'

import StatusActions from './StatusActions'
import DownloadIcon from '@components/Icon/DownloadCircled'
import ExperienceIcon from '@components/Icon/Experience'
import FeeIcon from '@components/Icon/Fee'
import ChevronIcon from '@components/Icon/IconDown'
import LanguageIcon from '@components/Icon/Language'
import PositionIcon from '@components/Icon/Position'
import CalendarIcon from '@components/Icon/Calendar'
import InterviewIcon from '@components/Icon/Interview'
import ScreeningIcon from '@components/Icon/Screening'
import TreeIcon from '@components/Icon/Tree'
import Spinner from '@components/spinner'
import _ from 'lodash'

class ExpertProfile extends Component {
  static propTypes = {
    modalStore: PropTypes.object,
    staticData: PropTypes.object,
    eplStore: PropTypes.object
  }

  constructor(props) {
    super(props)
    extendObservable(this, {
      loading: false,
      error: null,
      languages: []
    })

    const fieldsHiddenToExpert = JSON.parse(
      get(this.props.modalStore, 'props.epl.epl.fieldsHiddenToExpert') || '"[]"'
    )

    if (!fieldsHiddenToExpert.includes('languages')) {
      this.loadLanguages()
    }

    if (!fieldsHiddenToExpert.includes('recordings')) {
      this.loadRecordings()
    }
  }

  renderDate(startDate, endDate) {
    if (!startDate && !endDate) {
      return ''
    }

    const startDateString = startDate ? formatMonthYear(startDate) : ''
    const endDateString = endDate ? formatMonthYear(endDate) : 'Now'
    let dates
    if (startDateString && endDateString) {
      dates = `(${startDateString} - ${endDateString})`
    } else if (endDateString) {
      dates = `(${endDateString})`
    } else {
      dates = ''
    }

    return `${dates}`
  }

  loadRecordings = () => {
    const { modalStore, eplStore } = this.props
    const { epl } = modalStore.props.epl

    if (!epl) return null

    eplStore.getRecordingsFromEplHash(epl.hash)
  }

  loadLanguages = () => {
    const { modalStore } = this.props
    const expertId = get(modalStore, 'props.epl.epl.expert.id')

    if (!expertId) return

    this.loading = true
    this.error = null

    return userApi.getLanguages(expertId)
      .then(expertLanguages => {
        this.languages.replace(expertLanguages)
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.error = err
      })
  }

  renderExpertTitle = (staticData, epl) => {
    const countryName = staticData.renderCountry(epl.expert.address.countryId)
    if (!epl.expert.fullName) {
      return (
        <h3 className="client-view__expert-profile__title">
          Expert from {countryName}
        </h3>
      )
    } else {
      return (
        <h3 className="client-view__expert-profile__title">
          {[epl.expert.fullName, countryName].filter(e => e).join(', ')}
        </h3>
      )
    }
  }

  renderLoader = () => {
    return <Spinner />
  }

  renderScreening = epl => {
    if (!epl.screening) return null

    return (
      <div>
        <h4 className="client-view__expert-profile__subtitle">
          <ScreeningIcon />
          Screening
        </h4>

        <div
          className="expert-profile__text"
          dangerouslySetInnerHTML={{ __html: epl.screening }}
        />

        <hr className="separator separator--whitespace" />
      </div>
    )
  }

  renderPositions = epl => {
    const experiences = epl.expert.experiences.slice().sort((exp1, exp2) => {
      const isFirstExpRelevant = exp1.id === epl.relevantExperience.experienceId
      if (isFirstExpRelevant) return -1
      const isSecondExpRelevant =
        exp2.id === epl.relevantExperience.experienceId
      if (isSecondExpRelevant) return 1

      if (exp1.current && exp2.current) {
        return new Date(exp2.startDate) - new Date(exp1.startDate)
      }

      if (!exp1.current && !exp2.current) {
        return new Date(exp2.endDate) - new Date(exp1.endDate)
      }

      if (exp1.current) return -1
      if (exp2.current) return 1
      return 0
    })

    const positions = experiences.map(experience => {
      const position = get(experience, 'position.name', '')
      const companyName = get(experience, 'company.name', 'Unknown company')
      const date = this.renderDate(experience.startDate, experience.endDate)
      const isCurrentlyUsedExperience =
        experience.id === epl.relevantExperience.experienceId
      const classes = isCurrentlyUsedExperience
        ? 'client-view__expert-profile__experience client-view__expert-profile__experience--active'
        : 'client-view__expert-profile__experience'

      return (
        <li key={experience.id} className={classes}>
          <ChevronIcon rotate90 right />
          {[position, companyName, date].filter(e => e).join(', ')}
        </li>
      )
    })

    if (!positions.length) return null

    return (
      <div>
        <h4 className="client-view__expert-profile__subtitle">
          <PositionIcon />
          Positions
        </h4>
        <ul className="client-view__expert-profile__experience-list">
          {positions}
        </ul>
        <hr className="separator separator--whitespace" />
      </div>
    )
  }

  renderIndustryExperience = epl => {
    const industryExpertise = get(epl, 'industryExpertise')
    if (!industryExpertise) return null

    return (
      <div>
        <h4 className="client-view__expert-profile__subtitle">
          <ExperienceIcon />
          Industry experience
        </h4>
        <div
          className="client-view__expert-profile__text"
          dangerouslySetInnerHTML={{ __html: industryExpertise }}
        />
        <hr className="separator separator--whitespace" />
      </div>
    )
  }

  renderLanguagesAndRate = (staticData, epl) => {
    let languages = []
    if (!this.loading) {
      languages =
        this.languages &&
        this.languages.map(languageToUser => {
          const language = languageToUser.language
          const proficiencyId = languageToUser.languageProficiencyId
          const proficiency =
            staticData.names.languageProficiencies[proficiencyId]
          return (
            <li className="language" key={language.id}>
              <span className="language__name">{language.name}</span>
              <span className="language__proficiency">{proficiency}</span>
            </li>
          )
        })
    }

    const languageEl = languages.length ? (
      <div className="client-view__expert-profile__language m-r-xxl">
        <h4 className="client-view__expert-profile__subtitle">
          <LanguageIcon />
          Languages
        </h4>
        <ul className="client-view__language-list">{languages}</ul>
      </div>
    ) : null

    const rateEl = this.renderRate(staticData, epl)

    return (
      <div>
        <div className="client-view__expert-profile__language-rate">
          {languageEl}
          {rateEl}
        </div>
        <hr className="separator separator--whitespace" />
      </div>
    )
  }

  renderRate(staticData, epl) {
    if (!epl.fee && !epl.credits) return null
    const defaultPricingId = staticData.CONST.PRICINGS.PER_HOUR
    const expertPayment = staticData.getDataFromArray(
      epl.pricingId || defaultPricingId,
      'pricings'
    )

    return (
      <div className="client-view__expert-profile__language">
        <h4 className="client-view__expert-profile__subtitle client-view__expert-profile__rate">
          <FeeIcon />
          Fee
          <span className="client-view__expert-profile__rate-text">
            {renderExpertRate(staticData.names, epl)}
          </span>
        </h4>
        <div className="expert-profile__pricing">
          <span className="expert-profile__pricing-text">{expertPayment}</span>
        </div>
      </div>
    )
  }

  renderActions = () => {
    const { staticData, modalStore } = this.props
    const epl = get(modalStore, 'props.epl.epl')

    return (
      <div className="client-view__expert-profile__actions">
        <StatusActions epl={epl} staticData={staticData} inModal />
        <button
          key="close-profile"
          className="client-view__expert-profile__action client-view__expert-profile__action--right action button button--secondary"
          onClick={modalStore.close}>
          Close
        </button>
      </div>
    )
  }

  renderAvailability(epl) {
    return (
      <div>
        <h4 className="client-view__expert-profile__subtitle">
          <CalendarIcon />
          Availability
        </h4>

        <div
          className="expert-profile__text"
          dangerouslySetInnerHTML={{
            __html: epl.expertAvailability || 'Upon request'
          }}
        />

        <hr className="separator separator--whitespace" />
      </div>
    )
  }

  renderRecordings = (epl) => {
    const { recordings, generateRecordingStreamUrl } = this.props.eplStore

    if (!recordings.length) return null

    const groupedRecordings = Object.values(_.groupBy(recordings, 'recordingStart'))

    const recordingList = (
      <div>
        {groupedRecordings.length === 0 ? (
          <li style={{ padding: '2px 10px' }}>There are no recordings to show.</li>
        ) : (
          <div>
            <div className="meeting-topic">
              <span>{recordings[0].topic}</span>
            </div>
            {groupedRecordings.map((group) => {
              const meetingDateTime = formatDateTime(getDate(group[0].recordingStart))

              const video = group.find((recording) => recording.fileExtension === 'MP4')
              const videoURL = video && generateRecordingStreamUrl(epl, video)

              const audio = group.find((recording) => recording.fileExtension === 'M4A')
              const audioURL = audio && generateRecordingStreamUrl(epl, audio)

              const transcript = group.find((recording) => recording.fileExtension === 'VTT')
              const transcriptURL = transcript && generateRecordingStreamUrl(epl, transcript)

              return (
                <li>
                  <div className="meeting-files">
                    <span>{meetingDateTime}</span>
                    <div className={video ? '' : 'unavailable'} onClick={() => window.open(videoURL)}>[Video]</div>
                    <div className={audio ? '' : 'unavailable'} onClick={() => window.open(audioURL)}>[Audio]</div>
                    <div className={transcript ? '' : 'unavailable'} onClick={() => window.open(transcriptURL)}>[Transcript]</div>
                  </div>
                </li>
              )
            })}
          </div>
        )

        }
      </div>

    )

    return (
      <div>
        <h4 className="client-view__expert-profile__subtitle">
          <InterviewIcon />
          Recordings
        </h4>
        <ul className="expert-profile__experience-list recording__list">
          {recordingList}
        </ul>
        <hr className="separator separator--whitespace" />
      </div>
    )
  }

  renderContent = (staticData, epl) => {
    return (
      <div>
        {this.renderScreening(epl)}
        {this.renderAvailability(epl)}
        {this.renderPositions(epl)}
        {this.renderIndustryExperience(epl)}
        {this.renderLanguagesAndRate(staticData, epl)}
        {this.renderRecordings(epl)}
        {this.renderActions()}
      </div>
    )
  }

  render() {
    const { modalStore, staticData } = this.props
    const eplStore = modalStore.props.epl

    // this prevents rendering errors before the components unmounts
    if (!eplStore) return null

    const { epl } = eplStore

    const experience = eplStore.relevantExperience
    const position = get(experience, 'position.name', '')

    const content =
      this.loading === false
        ? this.renderContent(staticData, epl)
        : this.renderLoader()

    return (
      <div className="client-view__expert-profile">
        <TreeIcon />

        {this.renderExpertTitle(staticData, epl)}
        {position && (
          <div className="client-view__expert-profile__text client-view__expert-profile__text--large">
            {position},
          </div>
        )}
        <div className="client-view__expert-profile__text client-view__expert-profile__text--large">
          {eplStore.formattedExperience}
        </div>

        <hr className="separator separator--thick separator--whitespace" />

        <a
          href={`/api/epl/extern/${epl.hash}/export`}
          className="link client-view__expert-profile__link"
          download>
          <DownloadIcon />
          PDF
        </a>

        {content}
      </div>
    )
  }
}

ExpertProfile.defaultProps = {
  hideButtons: true,
  showCloseIcon: false,
  shouldCloseOnOverlayClick: true
}

export default inject(
  'modalStore',
  'staticData',
  'eplStore'
)(observer(ExpertProfile))
